export default (wrapper) => {
    const openButton = wrapper.querySelector('.j-vr-icon__open');
    const closeButton = wrapper.querySelector('.j-vr-icon__close');

    openButton.addEventListener('click', () => {
        wrapper.classList.add('is-open');
    });

    closeButton.addEventListener('click', () => {
        wrapper.classList.remove('is-open');
    });
};
